import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-widget-three',
  templateUrl: './widget-three.component.html',
  styleUrls: ['./widget-three.component.sass']
})
export class WidgetThreeComponent implements OnInit {
  data = [
    { label: 'type 1', value: 32 },
    { label: 'type 2', value: 24 },
    { label: 'type 3', value: 54 },
    { label: 'type 4', value: 16 }
  ]

  constructor() { }

  ngOnInit(): void {
  }

}
